import{css as t}from"@mui/material/styles";import e from"styled-components";const i={left:"left",center:"center",right:"right"},o={left:"flex-start",center:"center",right:"flex-end"},n=e("div")`
  width: 100%;

  ${({moduleHasButtons:e})=>e&&t`
      margin-top: ${({theme:t})=>t.spacing(18)};
      ${({theme:t})=>t.breakpoints.down("md")} {
        margin-top: ${({theme:t})=>t.spacing(10)};
      }
    `};

  display: flex;
  ${({theme:t})=>t.breakpoints.down("md")}
  margin-bottom: ${({theme:t})=>t.spacing(8)};
  flex-direction: column;
  align-items: ${({alignment:t})=>o[t]};

  p {
    margin-top: 0;
    font-size: ${({theme:t})=>t.typography.body1.fontSize};
    text-align: ${({alignment:t})=>i[t]};

    :empty {
      margin-top: ${({theme:t})=>t.spacing(0)};
      margin-bottom: ${({theme:t})=>t.spacing(0)};
    }
  }

  a {
    position: relative;
    display: inline-block;
    width: fit-content;
    font-weight: ${({theme:t})=>t.typography.subtitle1.fontWeight};
    line-height: 1;
    color: ${({theme:t})=>t.palette.common.white};
    text-decoration: none;
    border-bottom: 1px solid ${({theme:t})=>t.palette.common.white};
  }
`;export{n as FooterDiv};
//# sourceMappingURL=styles.js.map
